package org.moxultimate.topwithmox.navigation

// ─────────────────────────────────────────────────────────────────────────────
// AppRoutes — single source of truth for every URL in the app
//
// How to add a new page:
//   1. Create the @Page file under pages/ (file path = route).
//   2. Add a `const val` here for the path string.
//   3. If the page accepts query params, add a typed builder fun below.
//   4. Add a named `fun go<PageName>()` inside AppNavigator in Navigation.kt.
// ─────────────────────────────────────────────────────────────────────────────

object NavRoute {
    const val DASHBOARD = "/"
    const val ABOUT   = "/about"
    const val PREVIEW = "/preview"
    const val ARCHITECTURE_PAGE = "/architecture"
    const val WALLPAPER = "/wallpaper"
    const val WALLPAPER_DETAILS = "/wallpaperdetails"
    const val WALLPAPER_CRUD = "/wallpaper-crud"
    const val PRODUCTS = "/products"
    const val PRODUCT_CRUD = "/products-crud"
    const val PRODUCT_ADD = "/productadd"
    const val PRODUCT_UPDATE = "/productupdate"
    const val PRODUCT_ITEM_ADD = "/productitemadd"
    const val PRODUCT_ITEM_UPDATE = "/productitemupdate"
    const val WALLPAPER_ADD = "/wallpaperadd"
    const val WALLPAPER_UPDATE = "/wallpaperupdate"
    const val APPS = "/apps"
    const val APPS_CRUD = "/apps-crud"
    const val APPS_ADD = "/appsadd"
    const val APPS_UPDATE = "/appsupdate"
    const val SHOWS = "/shows"
    const val SHOWS_CRUD = "/shows-crud"
    const val SHOWS_ADD = "/showsadd"
    const val SHOWS_UPDATE = "/showsupdate"
    const val PANORAMA = "/panorama"
    const val TECH = "/tech"
    const val TECH_CRUD = "/tech-crud"
    const val TECH_ADD = "/techadd"
    const val TECH_UPDATE = "/techupdate"
    const val PRODUCT_DETAIL = "/productdetail"

    /**
     * panorama
     * Builds the panorama route URL with an optional image source.
     *
     * @param src URL of the 360° image to display; empty string uses the default placeholder.
     */
    fun panorama(src: String): String = if (src.isBlank()) PANORAMA
        else build(PANORAMA, mapOf(NavParams.PANORAMA_SRC to src))

    // ── Add new routes below ──────────────────────────────────────────────
    // const val PROFILE = "/profile"
    // const val SETTINGS = "/settings"

    // ── Typed path builders for routes that need query params ─────────────
    // fun profile(userId: String) = build(PROFILE, mapOf(NavParams.USER_ID to userId))

    /**
     * Builds a full path string from [route] and an optional [params] map.
     * Keys and values are URI-encoded so they are safe to include in a URL.
     */
    fun build(route: String, params: Map<String, String> = emptyMap()): String {
        if (params.isEmpty()) return route
        val query = params.entries.joinToString("&") { (k, v) ->
            "${encodeURIComponent(k)}=${encodeURIComponent(v)}"
        }
        return "$route?$query"
    }


}
